// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"66b9ba8c","453":"89eeb30f","455":"28728fee","977":"33f5b457"}[chunkId] + ".chunk.js";
};